import React from 'react';
import classnames from 'classnames';
import { Checkbox, mergeStyleSets } from '@fluentui/react';

import SpanWithTooltip from 'src/components/base/SpanWithTooltip';

const classNames = mergeStyleSets({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

});

export default ({ tooltip, label, useNativeLabel = false, className, styles, ...props}) => {
  return (
    <div className={classnames(!useNativeLabel && classNames.root, className)} style={styles?.root} >
      {!useNativeLabel && <SpanWithTooltip label={label} tooltip={tooltip} styles={styles?.span} />}
      <Checkbox {...props} styles={styles?.checkbox} label={useNativeLabel && label}/>
    </div>
  );
}

